import React from 'react';
import '../styles/About.css';

function Contact() {
    return (
        <div className="contact">
            <div>
                <h2>How to contact me?</h2>
            </div>
            <div>
                <p>Email: AaxellD@gmail.com</p>
                <p>Phone: 706-331-6442</p>
                <p>Location: Marietta, GA</p>
                <p><a href="https://github.com/AaxellD">GitHub</a></p>
                <p><a href="https://www.linkedin.com/in/xanderdean/">LinkedIn</a></p>

            </div>
        </div>
    )
}

export default Contact
